export default __webpack_public_path__ + "static/media/speed-icon.3d4fb507.webp";